const AdminType = {
    SET_IS_ADMIN:'SET_IS_ADMIN',
    SET_USER_ROLE:'SET_USER_ROLE',
    RESET: "RESET"
}
export default AdminType;